module.exports = __webpack_public_path__ + "media/assets/case_study_banner-32741c843e08f716b6c08de4fbd0adbc.jpg";